import { Header, DestinationCardDetails } from '@components';
import { DefaultLayout } from '@layouts';
import { ContentTemplate } from '@templates';
import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { stringify } from 'qs';
import groupBy from 'lodash/groupBy';
import classNames from 'classnames';
import orderBy from 'lodash/orderBy';
import { useRouter } from 'next/router';

export default function DestinationsPage({ cities }) {
  const { locale } = useRouter();

  const groupedByRegion = groupBy(
    orderBy(cities, 'attributes.name'),
    'attributes.region',
  );

  return (
    <>
      <NextSeo title={'Aditus | Destinations'} />

      <DefaultLayout enableAuthWall={false} showBreadcrumbs={false}>
        <ContentTemplate>
          {Object.entries(groupedByRegion).map((region, i) => {
            const [name, list] = region;
            const it = locale === 'it';

            return (
              <>
                <Header
                  title={name}
                  label={
                    list?.length + ' ' + (it ? 'Città' : 'Cities')
                  }
                />

                <section
                  className={classNames(
                    'container grid gap-6 max-w-7xl lg:gap-8 xl:gap-10',
                    'md:grid-cols-2 xl:grid-cols-3 pb-32',
                  )}
                >
                  {orderBy(list, 'attributes.name').map(
                    (city, i) => {
                      return (
                        <DestinationCardDetails
                          className="!w-full !h-110 relative !aspect-auto"
                          {...city?.attributes}
                          name={city?.attributes?.name}
                          slug={city?.attributes?.slug}
                          key={i}
                          img={
                            city?.attributes?.hero?.media?.data
                              .attributes
                          }
                        />
                      );
                    },
                  )}
                </section>
              </>
            );
          })}

          {/*  {cities.map((city, i) => {
              return (
                <DestinationCardDetails
                  className="!w-full !h-110 relative !aspect-auto"
                  name={city?.attributes?.name}
                  slug={city?.attributes?.slug}
                  img={
                    city?.attributes?.hero?.media?.data.attributes
                  }
                  key={i}
                />
              );
            })} */}
        </ContentTemplate>
      </DefaultLayout>
    </>
  );
}

export async function getServerSideProps({ locale, res }) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  const path = process.env.NEXT_PUBLIC_STRAPI;
  const qs = stringify(
    {
      populate: [
        'img',
        'img.media',
        'hero',
        'hero.media',
        'city',
        'site',
        'coordinates',
      ],
      locale,
    },
    { encodeValuesOnly: true },
  );

  // --- Ranking
  const getCities = await fetch(`${path}/cities?${qs}`);
  const cities = await getCities.json();

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      cities: cities?.data || [],
    },
  };
}
